import constants from 'app/constants'

/**
 * Parses the input elements into their categories
 *
 * @param {object} props - the input props
 * @returns {object} the category groups
 */
export default function parseCategories (props) {
  const { categoryConfig, elements } = props

  const categories = constants.AVATAR_LAYERS.reduce((res, category) => {
    res[category] = []

    return res
  }, {})

  elements.forEach(element => {
    const category = element.layer

    if (!constants.AVATAR_LAYERS.includes(category)) {
      console.error('Layer of type not found:', category)

      return
    }

    const config = categoryConfig[category] || {}
    const canDeselect =
      config?.isRequired !== undefined ? !config.isRequired : true

    categories[category].push({
      ...element,
      layerLabel: config?.label,
      codes: { [category]: element.id },
      canDeselect
    })
  })

  return categories
}
